import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ImagilityBaseResponse } from '../../../data/models/response.model';

@Injectable({
    providedIn: 'root'
})
export class FindPetitionerService {

    constructor(private http: HttpClient) {
    }

    getEmployerList(param) {
        return this.http.get(`/lp/getEmployerMaster?searchval=` + param).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status) {
                    return response.data;
                }
            })
        );
    }

    getNaicsList(param) {
      return this.http.get(`/lp/naicsMaster?searchval=` + param).pipe(
          map((response: ImagilityBaseResponse) => {
              if (response.status) {
                  return response.data;
              }
          })
      );
  }

  findEmployerList(payload){
    return this.http.post(`/lp/findEmployerList`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
          if (response.status == 200) {
              return response.data;
          }
      })
  )
  }

  markFavourite(beneficiaryId, companyId){
    return this.http.post(`/lp/favoriteCompany?beneficiaryId=${beneficiaryId}&companyId=${companyId}`, {}).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getGcFilings(payload){
    return this.http.post(`/lp/gcFilings`, payload).pipe(
        map((response: ImagilityBaseResponse) => {
            if (response.status == 200) {
                return response.data;
            }
        })
      );
  }

  getLcaFilings(payload){
    return this.http.post(`/lp/lcaFilings`, payload).pipe(
        map((response: ImagilityBaseResponse) => {
            if (response.status == 200) {
                return response.data;
            }
        })
      );
  }

  getPetitonData(payload){
    return this.http.post(`/lp/petitonData`, payload).pipe(
        map((response: ImagilityBaseResponse) => {
            if (response.status == 200) {
                return response.data;
            }
        })
      );
  }

}
